// react
import styled from 'styled-components';
import { Icon } from '@/components/atoms/Icon/Icon';

/**
 * TextIcon renders a text with icon.
 */
export const TextIcon = ({ text, centerText, showIcon }: TextIconProps) => {
  return (
    <TextContainer style={{ justifyContent: centerText ? 'center' : 'left' }}>
      {showIcon && (
        <IconWrapper>
          <Icon icon='check-circle' fontSize={18} />
        </IconWrapper>
      )}
      <GreetingText style={{ textAlign: centerText ? 'center' : 'left' }}>
        {text}
      </GreetingText>
    </TextContainer>
  );
};

const TextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing[12]};
`;

const IconWrapper = styled.div`
  color: ${(props) => props.theme.color.success[40]};
`;

const GreetingText = styled.div`
  font: ${(props) => props.theme.typography.body.lg.regular};
  text-align: left;
  color: ${(props) => props.theme.color.neutral[90]};
`;

interface TextIconProps {
  text: string;
  centerText: boolean;
  showIcon: boolean;
}

TextIcon.displayName = 'TextIcon';

export default TextIcon;
